export const constants = {
  APPLY_PROVIDER: '发布WeLink第三方企业应用,需先申请成为WeLink服务商',
  XCLOUD_APPLY_PROVIDER: '发布第三方企业应用，需先申请成为服务商',
  JION_TIGS: '请联系租户管理员入驻'
}
